import dayjs from "dayjs";

export enum MStorageEnum {
  /** 本地历史记录 */
  LOCAL_HOTEL_SEARCH_HISTORY = "Local_Hotel_Search_History"
}
// 前缀和过期时间定义
const prefix = "Y__";
export const expriseSevenDays = 7 * 24 * 3600;
export const expriseMonth = 30 * 24 * 3600;
export const expriseHalfMonth = 15 * 24 * 3600;

export const MStorage = {
  //key--键，data--值(字符串)，expires--有效时间，expires以秒为单位，且为正整数
  setStorageSync: function (key: MStorageEnum, data: any, expires?: number) {
    const storeKey = prefix + key;

    //未传递有效时间，直接使用原存储方法:
    if (!expires) {
      return localStorage.setItem(storeKey, JSON.stringify(data));
    }
    // 校验 expires 是否为正整数
    if (!Number.isInteger(expires) || expires <= 0) {
      throw new Error("参数错误，有效时间请使用正整数类型！");
    }

    // 计算过期时间戳
    const now = Date.now();
    const expirationTime = now + expires * 1000; // 毫秒为单位
    const expirationTimeStr = dayjs(expirationTime).format(
      "YYYY-MM-DD HH:mm:ss"
    );

    // 保存数据到 localStorage
    localStorage.setItem(
      storeKey,
      JSON.stringify({
        data,
        expires: expirationTimeStr
      })
    );
  },
  //提取：
  getStorageSync: function (key: MStorageEnum) {
    const storeKey = prefix + key;

    // 获取存储的内容
    let storedData: any = localStorage.getItem(storeKey);
    if (!storedData) return null;

    try {
      storedData = JSON.parse(storedData);
    } catch (error) {
      console.error("存储数据格式错误", error);
      return null;
    }

    // 如果没有设置过期时间，直接返回数据
    if (typeof storedData !== "object" || !storedData.expires) {
      return storedData;
    }

    // 判断是否过期
    const now = Date.now();
    const expirationTime = dayjs(storedData.expires).valueOf(); // 转为时间戳
    if (now < expirationTime) {
      return storedData.data; // 未过期
    }

    // 已过期，删除存储项
    localStorage.removeItem(storeKey);
    return null;
  },
  // 删除指定 key 的存储项
  removeStorageSync: function (key: MStorageEnum) {
    const storeKey = prefix + key;
    localStorage.removeItem(storeKey);
  }
};
